import IKImageWrapper from './IKImageWrapper'
export default IKImageWrapper
